
export const getBidStatus = (bid) => {
  if (!bid) return "";
  if (bid.isAccepted) return "Accepted";
  if (bid.isCanceled) return "Canceled";
  if (bid.isAwarded) return "Awarded";
  if (bid.isSubmitted) return "Submitted";
  if (bid.isDeclined) return "Declined";
  if (bid.isWithdrawn) return "Withdrawn";
  if (bid.isExpired) return "Expired";
  return "---";
};

export const BIDDER_STATUS = {
  PENDING: "PENDING",
  REGISTERED: "REGISTERED",
  DENIED: "DENIED",
  SUSPENDED: "SUSPENDED",
};
